import { render, staticRenderFns } from "./ModalItemBemPermanenteView.vue?vue&type=template&id=726471bd&scoped=true"
import script from "./ModalItemBemPermanenteView.vue?vue&type=script&lang=js"
export * from "./ModalItemBemPermanenteView.vue?vue&type=script&lang=js"
import style0 from "./ModalItemBemPermanenteView.vue?vue&type=style&index=0&id=726471bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726471bd",
  null
  
)

export default component.exports